import { jsx as _jsx } from "react/jsx-runtime";
export function Highlight({ parts, className }) {
    return (_jsx("span", { className: className, children: parts.map((part, index) => part.match ? (_jsx("mark", { className: "highlight__match", children: part.text }, index)) : (_jsx("span", { children: part.text }, index))) }));
}
//# sourceMappingURL=Highlight.js.map